import React from 'react';

export const BrandStrip = ({ data, speed = 32, reverse = false, className = '' }) => {
  const loop = [...data, ...data, ...data];

  return (
    <div className={`brand-strip-band ${className}`} data-testid="brand-strip-band">
      <div className="brands-marquee">
        <div
          className={`brands-marquee-track ${reverse ? 'reverse' : ''}`}
          style={{ animationDuration: `${speed}s` }}
        >
          {loop.map((brand, index) => (
            <div
              key={`${brand.slug}-${index}`}
              className={`brand-strip-item ${brand.slug === 'north-bridge' ? 'is-northbridge' : ''}`}
            >
              <img
                src={brand.image}
                alt={brand.name}
                className="brand-strip-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
